import React, { useEffect, useState } from 'react';
import { History, Search, Smartphone, Monitor } from 'lucide-react';

const AuditTrail = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const BASE_URL = process.env.REACT_APP_API_URL;


  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`${BASE_URL}/api/logs`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setLogs(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Helper formatting tanggal
  const formatTime = (isoString) => {
    return new Date(isoString).toLocaleString('id-ID', {
      day: 'numeric', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  };

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8">
      <div className="mb-6">
        <h1 className="text-2xl md:text-3xl font-serif text-slate-900 flex items-center gap-3">
          <History className="text-amber-600" />
          Audit Trail Sistem
        </h1>
        <p className="text-slate-500 text-sm mt-1">Rekaman aktivitas pengguna (Login, Update, Aksi Sistem).</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="bg-slate-900 text-white">
              <tr>
                <th className="px-6 py-4 font-bold uppercase tracking-wider text-xs">Waktu</th>
                <th className="px-6 py-4 font-bold uppercase tracking-wider text-xs">User</th>
                <th className="px-6 py-4 font-bold uppercase tracking-wider text-xs">Aksi</th>
                <th className="px-6 py-4 font-bold uppercase tracking-wider text-xs">Detail</th>
                <th className="px-6 py-4 font-bold uppercase tracking-wider text-xs">IP / Device</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {logs.map((log) => (
                <tr key={log.id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-3 text-slate-500 font-mono text-xs whitespace-nowrap">
                    {formatTime(log.created_at)}
                  </td>
                  <td className="px-6 py-3 font-bold text-slate-800">
                    {log.username}
                  </td>
                  <td className="px-6 py-3">
                    <span className={`px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wide border ${
                      log.action.includes('LOGIN') ? 'bg-green-50 text-green-700 border-green-200' :
                      log.action.includes('DELETE') ? 'bg-red-50 text-red-700 border-red-200' :
                      'bg-blue-50 text-blue-700 border-blue-200'
                    }`}>
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-3 text-slate-600 max-w-xs truncate" title={log.details}>
                    {log.details}
                  </td>
                  <td className="px-6 py-3 text-xs text-slate-400">
                    <div className="flex flex-col">
                      <span className="font-mono text-slate-600">{log.ip_address}</span>
                      <span className="truncate max-w-[150px]" title={log.user_agent}>
                        {log.user_agent && log.user_agent.includes('Mobile') ? 'Mobile Device' : 'Desktop Browser'}
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {logs.length === 0 && !loading && (
            <div className="p-8 text-center text-slate-400">Belum ada aktivitas terekam.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditTrail;